<h3 class="mt-4">Upload your video</h3>
<div class="brd mb-10 commonFormsCss col-lg-10 upload">
  <span class="note fileinfo">Filename naming convention: Use only alpha numeric and underscore.</span>
  <input type="file" #fileInput accept=".mp4, .mov" (change)="validateFile($event)" />
  <span class="fileinfo">*max upload : 100mb</span>
  <span class="fileinfo">*file format : .mp4, .mov</span>

  <div *ngIf="response.message !== ''" class="mt-2 mb-2">
    <b class="mt-3 mb-3" [ngClass]="response.color">{{ response.message }}</b>
  </div>

  <div _ngcontent-twi-c209="" class="col-md-12 mt-10 mb-5 pr-0">
    <button *ngIf="isValidFile && !isClicked" role="button" type="button" class="ba-btn btn-thin pull-right" id="buttonupload" (click)="openConsent()">Upload</button>
    <button *ngIf="!isValidFile || isClicked" disabled type="button" class="ba-btn btn-thin pull-right">Upload</button>
  </div>
</div>

<ng-template [ngIf]="fileList.length > 0">
  <div class="brd col-lg-10 ListOfFiles">
    <h4 class="mb-3">List of uploaded files</h4>
    <ul *ngFor="let video of fileList; let i = index">
      <li class="flexAside">
        <a (click)="playVideo(i)" data-bs-toggle="modal" data-bs-target="#videoPlayPopup" class="video-play">
          <i class="fa fa-play-circle me-2" aria-hidden="true"></i>
          <span class="videoName">{{ video }}</span>
        </a>
        <div class="icons">
          <button class="fa fa-check" aria-hidden="true"></button>
          <button class="fa fa-trash me-0" data-bs-toggle="modal" data-bs-target="#DeleteVideoConfirmation" (click)="deleteConfirmation(i)"></button>
        </div>
      </li>
    </ul>
  </div>
</ng-template>
<div class="modal fade subscribe-modal" id="videoPlayPopup" (click)="closeVideoPopup($event)" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content center-model-content">
      <video #videoElement controls autoplay controlsList="nodownload" width="800" height="500" [src]="videoPlayUrl"></video>
    </div>
  </div>
</div>

<!-- add consent pop up -->
<div class="modal consent" #consentAccept id="acceptConsent" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" *ngFor="let consentFeature of consentFeatures.consentSectionCard">
      <div class="modal-header text-center">
        <div class="modal-title text-center">
          <div [innerHtml]="returnHtmlFromRichText(consentFeature.richTextBody) || '' | mdToHtml"></div>
        </div>
      </div>
      <div class="modal-body text-center">
        <button type="button" class="grayBtn" (click)="consent('accept')" data-bs-dismiss="modal" aria-label="Close">Accept</button>
      </div>
      <div class="modal-footer flexAside">
        <a class="reject" (click)="consent('declined')" data-bs-dismiss="modal" aria-label="Close">Reject</a>
        <a [href]="consentFeature.buttonUrl" target="_blank">{{ consentFeature.buttonText }}</a>
      </div>
    </div>
  </div>
</div>

<!-- add consent pop up-->

<!-- Delete Confirmation Model -->
<div class="modal cancelPopup" id="DeleteVideoConfirmation" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Delete Confirmation</h5>
        <button type="button" class="btn-close close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">Are you sure you want to delete the video ?</div>
      <div class="modal-footer">
        <div class="jconfirm-buttons">
          <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-default" (click)="deleteFile()">Yes</button>
          <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-default">cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
